import { createFileRoute } from "@tanstack/react-router";
import { StbBuyersChecklistPage } from "@/components/guides/StbBuyersChecklistPage";
import { stbBuyersChecklistSeo } from "@/lib/page-seo";
import checklistOgImage from "@/assets/guides/stb-buyers-checklist-og.jpg";

export const Route = createFileRoute("/guides/iptv-stb-buyers-checklist")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) =>
    stbBuyersChecklistSeo(
      loaderData?.href ?? "/guides/iptv-stb-buyers-checklist",
      checklistOgImage,
    ),
  component: StbBuyersChecklistPage,
});
